module.exports = __webpack_public_path__ + "images/products/autoship-pods-069a3b36.png";